var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "129e375ec4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30.882812 3 L 777 3 L 777 809 L 30.882812 809 Z M 30.882812 3 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#129e375ec4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e44d26",
    d: "M 27.980469 3.058594 L 30.882812 36.875 L 92.257812 714.429688 L 402.039062 808.148438 L 711.820312 714.429688 L 776.09375 3.058594 Z M 95.640625 64.894531 L 708.4375 64.894531 L 654.066406 667.566406 L 402.039062 743.898438 L 150.007812 667.566406 Z M 210.660156 188.570312 L 233.132812 374.082031 L 508.117188 374.082031 L 490.476562 521.910156 L 402.039062 555.726562 L 313.597656 521.910156 L 303.449219 435.917969 L 240.625 435.917969 L 256.089844 566.355469 L 402.039062 622.15625 L 547.988281 566.355469 L 578.191406 312.246094 L 288.953125 312.246094 L 281.21875 250.40625 L 585.683594 250.40625 L 593.175781 188.570312 Z M 210.660156 188.570312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.9ca6aae326c658f7b3ee3b783dd585af.svg";
export { ForwardRef as ReactComponent };